import React from 'react';
import { withFaroProfiler } from '@grafana/faro-react';
import { useOidc } from '@axa-fr/react-oidc';

/**
 * Page component split out from App to allow for profiling
 */
const Page = ({
  Component,
  path,
  configureSidebar,
  userDetails,
  oauthAccessToken,
  accessDetails,
  portalJwt,
  startTracking,
  setTheme,
  configureNavigation,
  featureFlags,
}: Omit<ModuleComponentProps, 'initAuth'> & {
  Component: React.ComponentType<ModuleComponentProps>;
}): JSX.Element => {
  const { isAuthenticated, login } = useOidc();
  const initAuth = () => {
    if (!isAuthenticated) {
      login();
    }
  };

  return (
    <Component
      path={path}
      configureSidebar={configureSidebar}
      userDetails={userDetails}
      oauthAccessToken={oauthAccessToken}
      accessDetails={accessDetails}
      portalJwt={portalJwt}
      startTracking={startTracking}
      setTheme={setTheme}
      configureNavigation={configureNavigation}
      featureFlags={featureFlags}
      initAuth={initAuth}
    />
  );
};

export default withFaroProfiler(Page);
